const OPENAI_API_KEY = "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";

export default OPENAI_API_KEY;